export const Games = [
 {
   "id": "Neir Replicant ",
   "img": "https://cdn.mobygames.com/covers/6317592-nier-replicant-ver122474487139-xbox-one-front-cover.png",
   "link": "https://store.steampowered.com/app/1113560/NieR_Replicant_ver122474487139/",
   "year": 2021
},
 {
   "id": "Baba is You",
   "img": "https://images.igdb.com/igdb/image/upload/t_cover_big/co2hqt.jpg",
   "link": "https://store.steampowered.com/app/736260/Baba_Is_You/",
   "year": 2021
},
 {
   "id": "Furi",
   "img": "https://cdn.mobygames.com/covers/2070096-furi-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/423230/Furi/",
   "year": 2021
},
 {
   "id": "Evil Tonight",
   "img": "https://thumbnails.pcgamingwiki.com/e/e3/Evil_Tonight_cover.jpg/450px-Evil_Tonight_cover.jpg'",
   "link": "https://store.steampowered.com/app/1480830/Evil_Tonight/",
   "year": 2021
},
 {
   "id": "The Good Life",
   "img": "https://cdn.mobygames.com/covers/10245098-the-good-life-windows-apps-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1452500/The_Good_Life/",
   "year": 2021
},
 {
   "id": "Alisa",
   "img": "https://cdn.mobygames.com/covers/18638086-alisa-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1335530/Alisa/",
   "year": 2021
},
 {
   "id": "Tres Bashers",
   "img": "https://img.itch.zone/aW1nLzcwOTgyMTIucG5n/original/EYygQQ.png",
   "link": "https://store.steampowered.com/app/1595640/TresBashers/",
   "year": 2021
},
 {
   "id": "Simulacra Pipe Dreams ",
   "img": "https://i.ytimg.com/vi/To7elMbIoCU/maxresdefault.jpg",
   "link": "https://store.steampowered.com/app/878320/SIMULACRA_Pipe_Dreams/",
   "year": 2021
},
 {
   "id": "Sumire",
   "img": "https://howlongtobeat.com/games/93035_Sumire.jpg",
   "link": "https://store.steampowered.com/app/1335230/Sumire/",
   "year": 2021
},
{ 
 "id": "Dragonball FighterZ",
  "img": "https://cdn.mobygames.com/covers/1420466-dragon-ball-fighterz-playstation-4-front-cover.jpg",
  "link": "https://store.steampowered.com/app/678950/DRAGON_BALL_FighterZ/",
  "year": 2021
 }, 
{ 
 "id": "Guilty Gear Strive", 
  "img": "https://howlongtobeat.com/games/78849_Guilty_Gear_Strive.jpg?width=250",
  "link": "https://store.steampowered.com/app/1384160/GUILTY_GEAR_STRIVE/",
  "year": 2021
 }, 
 {
   "id": "Deadeus",
   "img": "https://img.itch.zone/aW1hZ2UvNDY0MjU0LzIzNjE4MTEuanBn/original/yRxlUc.jpg",
   "link": "https://izma.itch.io/deadeus",
   "year": 2021
},
 {
   "id": "Eastward",
   "img": "https://cdn.mobygames.com/covers/11220149-eastward-nintendo-switch-front-cover.jpg",
   "link": "https://store.steampowered.com/app/977880/Eastward/",
   "year": 2021
},
 {
   "id": "Soul Void",
   "img": "https://img.itch.zone/aW1nLzEyNjA1NjA5LnBuZw==/original/qprnDq.png",
   "link": "https://kadabura.itch.io/soul-void",
   "year": 2021
},
 {
   "id": "Jump King ",
   "img": "https://cdn.mobygames.com/covers/8842377-jump-king-nintendo-switch-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1061090/Jump_King/",
   "year": 2021
},
 {
   "id": "Recettear",
   "img": "https://www.mobygames.com/images/covers/l/222019-recettear-an-item-shop-s-tale-windows-front-cover.jpg",
   "link": "https://store.steampowered.com/app/70400/Recettear_An_Item_Shops_Tale/",
   "year": 2021
},
 {
   "id": "Umihare Kawase ",
   "img": "https://howlongtobeat.com/games/Umihara_Kawase_Coverart.png",
   "link": "https://store.steampowered.com/app/384690/Umihara_Kawase/",
   "year": 2021
},
 {
   "id": "Darkwood",
   "img": "https://www.mobygames.com/images/covers/l/560068-darkwood-playstation-4-front-cover.jpg",
   "link": "https://store.steampowered.com/app/274520/Darkwood/",
   "year": 2021
},
 {
   "id": "I Am On Obversation Duty",
   "img": "https://repack-games.com/wp-content/uploads/2021/11/Im-on-Observation-Duty-Repack-Games.jpg",
   "link": "https://store.steampowered.com/app/1046820/Im_on_Observation_Duty/",
   "year": 2021
},
 {
   "id": "The Horror of Salazar House",
   "img": "https://img.itch.zone/aW1hZ2UvNjcyODY5LzM2OTQzOTguZ2lm/original/Mv1Sje.gif",
   "link": "https://store.steampowered.com/app/1046820/Im_on_Observation_Duty/",
   "year": 2021
},
 {
   "id": "Ender Lillies",
   "img": "https://cdn.mobygames.com/covers/10180895-ender-lilies-quietus-of-the-knights-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1369630/ENDER_LILIES_Quietus_of_the_Knights/",
   "year": 2021
},
 {
   "id": "Travis Strikes Again",
   "img": "https://cdn.mobygames.com/covers/7247709-travis-strikes-again-no-more-heroes-nintendo-switch-front-cover.jpg",
   "link": "https://store.steampowered.com/app/961490/Travis_Strikes_Again_No_More_Heroes_Complete_Edition/",
   "year": 2021
},
 {
   "id": "Sanguine Sanctum",
   "img": "https://cdn.cloudflare.steamstatic.com/steam/apps/892780/capsule_616x353.jpg",
   "link": "https://modus-interactive.itch.io/sanguine-sanctum",
   "year": 2021
},
 {
   "id": "No more Heros ",
   "img": "https://cdn.mobygames.com/covers/5137087-no-more-heroes-wii-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1420290/No_More_Heroes/",
   "year": 2021
},
 {
   "id": "No More Heros 2",
   "img": "https://cdn.mobygames.com/covers/5918631-no-more-heroes-2-desperate-struggle-wii-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1420300/No_More_Heroes_2_Desperate_Struggle/",
   "year": 2021
},
 {
   "id": "No more Heros 3",
   "img": "https://cdn.mobygames.com/covers/7980626-no-more-heroes-iii-nintendo-switch-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1744330/No_More_Heroes_3/",
   "year": 2022
},
 {
   "id": "Little Nightmares 2",
   "img": "https://cdn.mobygames.com/covers/9639209-little-nightmares-ii-playstation-4-front-cover.jpg",
   "link": "https://store.steampowered.com/app/424840/Little_Nightmares/",
   "year": 2021
},
 {
   "id": "Little Nightmares",
   "img": "https://cdn.mobygames.com/covers/2405652-little-nightmares-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/860510/Little_Nightmares_II/",
   "year": 2021
},
 {
   "id": "The Door in the Basement ",
   "img": "https://i0.wp.com/www.skidrowreloaded.com/wp-content/uploads/2021/04/The-Door-in-the-Basement-pc-free-download.jpg",
   "link": "https://store.steampowered.com/app/1436810/The_Door_in_the_Basement/",
   "year": 2021
},
 {
   "id": "Simulacra ",
   "img": "https://cdn.mobygames.com/covers/8480937-simulacra-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/712730/SIMULACRA/",
   "year": 2021
},
 {
   "id": "Simulacra 2",
   "img": "https://cdn.mobygames.com/covers/8627128-simulacra-2-android-front-cover.png",
   "link": "https://store.steampowered.com/app/1011190/SIMULACRA_2/",
   "year": 2021
},
 {
   "id": "Critters for Sale",
   "img": "https://howlongtobeat.com/games/93118_Critters_for_Sale.jpg?width=250",
   "link": "https://store.steampowered.com/app/1078420/Critters_for_Sale/",
   "year": 2021
},
 {
   "id": "The friends of Ringo Ishikawa",
   "img": "https://cdn.mobygames.com/covers/10055095-the-friends-of-ringo-ishikawa-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/846110/The_friends_of_Ringo_Ishikawa/",
   "year": 2021
},
 {
   "id": "Sara is Missing",
   "img": "https://img.itch.zone/aW1hZ2UvODk0NTcvNDM3MDEyLnBuZw==/original/wsUNHD.png",
   "link": "https://saraismissing.itch.io/sim",
   "year": 2021
},
 {
   "id": "Anatomy",
   "img": "https://img.itch.zone/aW1hZ2UvNTUwMjMvMjQ2MDY3LnBuZw==/original/tc2HvB.png",
   "link": "https://kittyhorrorshow.itch.io/anatomy",
   "year": 2021
},
 {
   "id": "Persona 5 Strikers ",
   "img": "https://cdn.mobygames.com/covers/9713840-persona-5-strikers-playstation-4-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1382330/Persona_5_Strikers/",
   "year": 2021
},
 {
   "id": "Space Channel 5",
   "img": "https://cdn.mobygames.com/covers/4029370-space-channel-5-dreamcast-front-cover.jpg",
   "link": "https://store.steampowered.com/app/71260/Space_Channel_5_Part_2/",
   "year": 2021
},
 {
   "id": "Dere Evil.exe",
   "img": "https://howlongtobeat.com/games/59423_DERE_EVIL_EXE.jpg?width=250",
   "link": "https://store.steampowered.com/app/871950/DERE_EVIL_EXE/",
   "year": 2021
},
 {
   "id": "Peret em Heru ",
   "img": "https://images.igdb.com/igdb/image/upload/t_cover_big/co2wuh.jpg",
   "link": "https://rmarchiv.de/games/2254",
   "year": 2021
},
 {
   "id": "Haunted PS1 2021",
   "img": "https://img.itch.zone/aW1nLzU0OTQwODEuZ2lm/original/7Q2zqw.gif",
   "link": "https://hauntedps1.itch.io/demodisc2021",
   "year": 2021
},
 {
   "id": "Haunted PS1 2020",
   "img": "https://img.itch.zone/aW1nLzI5NTYyNDMucG5n/original/5wRe7h.png",
   "link": "https://hauntedps1.itch.io/demodisc2020",
   "year": 2021
},
 {
   "id": "Deedlit in Wonder Labyrinth ",
   "img": "https://cdn.mobygames.com/covers/11023124-record-of-lodoss-war-deedlit-in-wonder-labyrinth-playstation-4-f.jpg",
   "link": "https://store.steampowered.com/app/1203630/Record_of_Lodoss_WarDeedlit_in_Wonder_Labyrinth/",
   "year": 2021
},
 {
   "id": "Puzzling Peaks Exe",
   "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-7VExQYn_7MviiZjUu_UvJPNPSazhSlrqRQ&usqp=CAU",
   "link": "https://store.steampowered.com/app/1475420/Puzzling_Peaks_EXE/",
   "year": 2021
},
 {
   "id": "Terranigma",
   "img": "https://i.pinimg.com/564x/04/16/4e/04164e773c8a79c8e375fc1d3b5808af.jpg",
   "link": "https://en.wikipedia.org/wiki/Terranigma",
   "year": 2021
},
 {
   "id": "Return of the Obra Dinn",
   "img": "https://howlongtobeat.com/games/61882_Return_of_the_Obra_Dinn.jpg?width=250",
   "link": "https://store.steampowered.com/app/653530/Return_of_the_Obra_Dinn/",
   "year": 2021
},
 {
   "id": "Kick Master",
   "img": "https://i.pinimg.com/474x/fa/40/df/fa40dfc08232b21d2d132c4ef32044c6--nintendo-games-box-art.jpg",
   "link": "https://www.retrogames.cz/play_1384-NES.php?language=EN",
   "year": 2021
},
 {
   "id": "Cyber Shadow",
   "img": "https://howlongtobeat.com/games/42816_Cyber_Shadow.jpg?width=250",
   "link": "https://store.steampowered.com/app/861250/Cyber_Shadow/",
   "year": 2021
},
 {
   "id": "HopBound",
   "img": "https://play-lh.googleusercontent.com/qXRUMbSimbMSEHDiNtAO3emfODmY89-i0j3q-L0jght7pBkTjO5JWMlgV2yOHkgpqF0V",
   "link": "https://store.steampowered.com/app/1332890/HopBound/",
   "year": 2021
},
 {
   "id": "Eternal Ring",
   "img": "https://cdn.mobygames.com/covers/3906895-eternal-ring-playstation-2-front-cover.jpg",
   "link": "https://www.youtube.com/watch?v=BFD6p94_PNM",
   "year": 2021
},
 {
   "id": "Great Battle V",
   "img": "https://i.imgur.com/00x1FKj.png",
   "link": "https://www.romhacking.net/translations/3473/",
   "year": 2021
},
 {
   "id": "Siren",
   "img": "https://www.mobygames.com/images/covers/l/361231-siren-playstation-2-manual.jpg",
   "link": "https://www.youtube.com/watch?v=1nH_pdmh_yw",
   "year": 2021
},
 {
   "id": "Golden Light",
   "img": "https://howlongtobeat.com/games/82170_Golden_Light.jpg?width=250",
   "link": "https://store.steampowered.com/app/1245430/Golden_Light/",
   "year": 2021
},
 {
   "id": "Northbury Grove",
   "img": "https://img.itch.zone/aW1nLzE1Mjc1NDMucG5n/original/ahB5zs.png",
   "link": "https://scythedevteam.itch.io/nbg",
   "year": 2021
},
 {
   "id": "Powerdrill Massacre",
   "img": "https://howlongtobeat.com/games/89759_Power_Drill_Massacre.jpg?width=250",
   "link": "https://puppetcombo.itch.io/pdm",
   "year": 2021
},
 {
   "id": "M Stain",
   "img": "https://img.itch.zone/aW1nLzM5MTIzMDYuZ2lm/original/ngxsH5.gif",
   "link": "https://impostersyndrome.itch.io/mstain",
   "year": 2021
},
 {
   "id": "Cold Shot",
   "img": "https://www.freegameplanet.com/wp-content/uploads/2021/04/cold-shot-game-download.jpg",
   "link": "https://skydrow.itch.io/cold-shot",
   "year": 2021
},
 {
   "id": "The Salvation Project",
   "img": "https://img.itch.zone/aW1nLzY5MjYzMzguZ2lm/original/cQ%2BM2p.gif",
   "link": "https://lenat-1.itch.io/salvation-project",
   "year": 2021
},
 {
   "id": "SCP-087",
   "img": "https://static.wikia.nocookie.net/villains/images/6/69/SCP-087.jpg",
   "link": "https://inkghst.itch.io/scp-087",
   "year": 2021
},
 {
   "id": "Security Booth",
   "img": "https://static.wikia.nocookie.net/markiplier/images/2/2a/Security_Booth.jpg",
   "link": "https://3dkyle.itch.io/security-booth",
   "year": 2021
},
 {
   "id": "The Well",
   "img": "https://img.itch.zone/aW1nLzY4MzQ4MDkucG5n/original/CHxmaK.png",
   "link": "https://pantagruel.itch.io/the-well",
   "year": 2021
},
 {
   "id": "Burger & Frights",
   "img": "https://cdn.mobygames.com/covers/17438717-burger-frights-browser-front-cover.png",
   "link": "https://donitz.itch.io/burger-frights",
   "year": 2021
},
 {
   "id": "House in the Woods",
   "img": "https://img.itch.zone/aW1nLzMzMDk0MjUucG5n/original/0HWAv7.png",
   "link": "",
   "year": 2021
},
 {
   "id": "Milk inside a bag of Milk",
   "img": "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co2i8x.jpg",
   "link": "https://store.steampowered.com/app/1392820/Milk_inside_a_bag_of_milk_inside_a_bag_of_milk/",
   "year": 2021
},
 {
   "id": "VHS 1986",
   "img": "https://img.itch.zone/aW1nLzMyNDQyNTIuZ2lm/original/jy%2BjGG.gif",
   "link": "https://papercookies.itch.io/vhs-1986",
   "year": 2021
},
 {
   "id": "Nightslink",
   "img": "https://img.itch.zone/aW1hZ2UvOTQ2MDMzLzY4MTY1NDIucG5n/original/3eqbXq.png",
   "link": "https://noiseminded.itch.io/nightslink",
   "year": 2021
},
 {
   "id": "Morbus",
   "img": "https://img.itch.zone/aW1nLzYzMTYyNDUucG5n/original/ulJVSt.png",
   "link": "https://noiseminded.itch.io/morbus",
   "year": 2021
 },
 //2022 need to check games from 2021 Morbus
 {
   "id": "Micheal Jordan: Chaos is the Windy City",
   "img": "https://www.giantbomb.com/a/uploads/scale_medium/8/87790/1672012-box_mjcitwc.png",
   "link": "https://www.imdb.com/title/tt2054789/",
   "year": 2022
 },
 {
   "id": "Metal Gear Rising: Revengance",
   "link": "https://store.steampowered.com/agecheck/app/235460/",
   "img": "https://cdn.mobygames.com/covers/1205669-metal-gear-rising-revengeance-playstation-3-manual.jpg",
   "year": 2022
 },
 {
   "id": "Bladed Fury",
   "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnlPUJD9S_QCMjpGKumomZWELWyL7lle3iXLY63uHwBSoDA70FGQPwZOLwNFYBnamsXGk&usqp=CAU",
   "link": "https://store.steampowered.com/app/927250/",
   "year": 2022
 },
 {
   "id": "Monster Hunter: Rise",
   "img": "https://cdn.mobygames.com/covers/9846344-monster-hunter-rise-nintendo-switch-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1446780/MONSTER_HUNTER_RISE/",
   "year": 2022
 },
 {
   "id": "Pico Park",
   "img": "https://howlongtobeat.com/games/43026_PICO_PARK.jpg",
   "link": "https://store.steampowered.com/app/461040/PICO_PARKClassic_Edition/",
   "year": 2022
 },
 {
   "id": "Ruiner",
   "img": "https://cdn.mobygames.com/covers/3016789-ruiner-windows-apps-front-cover.jpg",
   "link": "https://store.steampowered.com/app/464060/RUINER/",
   "year": 2022
 },
 {
   "id": "Sable",
   "img": "https://howlongtobeat.com/games/59371_Sable_(2020).jpg?width=250",
   "link": "https://store.steampowered.com/app/757310/Sable/",
   "year": 2022
 },
 {
   "id": "The Heilwald Loophole",
   "img": "https://img.itch.zone/aW1nLzU1MjM0ODMucG5n/original/wgqdUR.png",
   "link": "https://store.steampowered.com/app/1697720/The_Heilwald_Loophole/",
   "year": 2022
 },
 {
   "id": "Dungeon of the Endless",
   "img": "https://cdn.mobygames.com/covers/1882780-dungeon-of-the-endless-xbox-one-front-cover.png",
   "link": "https://store.steampowered.com/app/249050/Dungeon_of_the_ENDLESS/",
   "year": 2022
 },
  {
   "id": "Who's Lila",
   "img": "https://steamuserimages-a.akamaihd.net/ugc/1852672630571880880/A3077F50DEF2702B38597482F8C6CD036BF35FE7/?imw=1024&&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
   "link": "https://store.steampowered.com/app/1697700/Whos_Lila/",
   "year": 2022
 },
 {
   "id": "Sifu",
   "img": "https://cdn.mobygames.com/covers/10638363-sifu-windows-front-cover.jpg",
   "link": "https://www.playstation.com/en-au/games/sifu/",
   "year": 2022
 },
 {
   "id": "KoF XV",
   "img": "https://cdn.mobygames.com/covers/10672979-the-king-of-fighters-xv-windows-apps-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1498570/THE_KING_OF_FIGHTERS_XV",
   "year": 2022
 },
 {
   "id": "Elden Ring",
   "img": "https://cdn.mobygames.com/covers/10371758-elden-ring-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1245620/ELDEN_RING/",
   "year": 2022
 },
 {
   "id": "Erica",
   "img": "https://cdn.nivoli.com/adventuregamers/images/screenshots/41996/erica-product-tile-01-ps4-us-16aug19__medium.jpg",
   "link": "https://store.steampowered.com/app/1514930/Erica/",
   "year": 2022
 },
 {
   "id": "Persona 4 Arena Ultimax",
   "img": "https://cdn.mobygames.com/covers/2027374-persona-4-arena-ultimax-playstation-3-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1602010/Persona_4_Arena_Ultimax/",
   "year": 2022
 },
 {
   "id": "ANNO: Mutationem",
   "img": "https://cdn.mobygames.com/covers/17678298-anno-mutationem-windows-apps-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1368030/ANNO_Mutationem/",
   "year": 2022
 },
 {
   "id": "Unbeatable [white label]",
   "img": "https://static-cdn.jtvnw.net/ttv-boxart/673594658_IGDB-272x380.jpg",
   "link": "https://store.steampowered.com/app/1290490/UNBEATABLE_white_label/",
   "year": 2022
 },
 {
   "id": "No Straight Roads",
   "img": "https://cdn.mobygames.com/covers/9478125-no-straight-roads-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1726190/No_Straight_Roads_Encore_Edition/",
   "year": 2022
 },
 {
   "id": "Oxenfree",
   "img": "https://cdn.mobygames.com/covers/1757669-oxenfree-xbox-one-front-cover.png",
   "link": "https://store.steampowered.com/app/388880/Oxenfree/",
   "year": 2022
 },
 {
   "id": "Cuphead",
   "img": "https://cdn.mobygames.com/covers/1122773-cuphead-windows-apps-front-cover.jpg",
   "link": "https://store.steampowered.com/app/268910/Cuphead/",
   "year": 2022
 },
 {
   "id": "Resident Evil 0",
   "img": "https://cdn.mobygames.com/covers/3912650-resident-evil-0-gamecube-front-cover.jpg",
   "link": "https://store.steampowered.com/agecheck/app/339340/",
   "year": 2022
 },
 {
   "id": "Resident Evil 1: Remake",
   "img": "https://howlongtobeat.com/games/Resident_Evil_HD_Remaster.jpg?width=250",
   "link": "https://store.steampowered.com/app/304240/Resident_Evil/",
   "year": 2022
 },
 {
   "id": "Resident Evil 2: Remake",
   "img": "https://cdn.mobygames.com/covers/7418146-resident-evil-2-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/883710/Resident_Evil_2/",
   "year": 2022
 },
 {
   "id": "Resident Evil 3: Remake",
   "img": "https://cdn.mobygames.com/covers/8541620-resident-evil-3-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/952060/Resident_Evil_3/",
   "year": 2022
 },
 {
   "id": "Resident Evil 4",
   "img": "https://cdn.mobygames.com/covers/7259541-resident-evil-4-playstation-2-manual.jpg",
   "link": "https://store.steampowered.com/app/254700/Resident_Evil_4",
   "year": 2022
 },
 {
   "id": "A Short Hike",
   "img": "https://images.gog-statics.com/9a5bb4f812c19118bf299010657590cab287c5302156a89a2d69dc9c108bd7b8.jpg",
   "link": "https://store.steampowered.com/app/1055540",
   "year": 2022
 },
 {
   "id": "Baroque",
   "img": "https://cdn.mobygames.com/covers/8637949-baroque-sega-saturn-front-cover.jpg",
   "link": "https://nervetower.neocities.org/guide",
   "year": 2022
 },
 {
   "id": "Spectral Mall Demo Disk",
   "img": "https://img.itch.zone/aW1nLzk4ODQ0NjgucG5n/original/OAKG0a.png",
   "link": "https://hauntedps1.itch.io/demo-disc-spectral-mall",
   "year": 2022
 },
 {
   "id": "Devil Daggers",
   "img": "https://howlongtobeat.com/games/34743_Devil_Daggers.jpg?width=250",
   "link": "https://store.steampowered.com/app/422970",
   "year": 2022
 },
 {
   "id": "Night at the Gates of Hell",
   "img": "https://static.wikia.nocookie.net/puppetcombo/images/7/74/FcqbClAXwAAjchE.jpg",
   "link": "https://store.steampowered.com/app/2026870/Night_At_the_Gates_of_Hell/",
   "year": 2022
 },
 {
   "id": "Cannon Dancer: Osman",
   "img": "https://assets-prd.ignimgs.com/2022/09/08/cannondancer-1662654163483.jpg",
   "link": "https://www.iningames.com/games/cannon-dancer-en",
   "year": 2022
 },
 {
   "id": "Scorn",
   "img": "https://cdn.mobygames.com/covers/11063527-scorn-windows-apps-front-cover.jpg",
   "link": "https://store.steampowered.com/app/698670",
   "year": 2022
 },
 {
   "id": "Signalis",
   "img": "https://cdn.mobygames.com/covers/11099601-signalis-playstation-4-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1262350",
   "year": 2022
 },
 {
   "id": "Romancing Saga: Minstrel Song",
   "img": "https://howlongtobeat.com/games/117563_Romancing_SaGa_Minstrel_Song_-_Remastered.jpg?width=250",
   "link": "https://store.steampowered.com/app/1793030/?utm_source=PCGamingWiki&utm_medium=PCGamingWiki&utm_campaign=PCGamingWiki",
   "year": 2022
 },
 {
   "id": "Devil May Cry: 5",
   "img": "https://cdn.mobygames.com/covers/7622168-devil-may-cry-5-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/601150/?utm_source=PCGamingWiki&utm_medium=PCGamingWiki&utm_campaign=PCGamingWiki",
   "year": 2022
 },
 {
   "id": "Mischief Makers",
   "img": "https://live.staticflickr.com/4896/44118129430_a983703923_b.jpg",
   "link": "https://www.mobygames.com/game/8090/mischief-makers/",
   "year": 2023
 },
 {
   "id": "Mega Man Legends",
   "img": "https://m.media-amazon.com/images/M/MV5BYWUzYmRkNjEtYWFkZS00OTYwLWFiNzMtZmViOTk5ZDM1OGUyXkEyXkFqcGdeQXVyMTA0MTM5NjI2._V1_FMjpg_UX1000_.jpg",
   "link": "https://www.mobygames.com/game/3322/mega-man-legends/",
   "year": 2023
 },
 {
   "id": "Mega Man Legends 2",
   "img": "https://cdn.mobygames.com/covers/4260849-mega-man-legends-2-playstation-front-cover.jpg",
   "link": "https://www.mobygames.com/game/4066/mega-man-legends-2/",
   "year": 2023
 },
 {
   "id": "Misadventures of Tron Bonne",
   "img": "https://assets-prd.ignimgs.com/2022/01/04/the-misadventures-of-tron-bonne-button-1641282060168.jpg",
   "link": "https://www.mobygames.com/game/4573/the-misadventures-of-tron-bonne/",
   "year": 2023
 },
 {
   "id": "Babbdi",
   "img": "https://cdn.cloudflare.steamstatic.com/steam/apps/2240530/capsule_616x353.jpg",
   "link": "https://store.steampowered.com/app/2240530/BABBDI/",
   "year": 2023
 },
{
   "id": "SkyGunner",
   "img": "https://now.estarland.com/images/products/87/55387/185141.jpg",
   "link": "http://www.hardcoregaming101.net/skygunner/",
   "year": 2023
 },
 {
   "id": "Shinobi",
   "img": "https://segaretro.org/images/thumb/c/cb/Shinobi_PS2_US_Manual.pdf/page1-2131px-Shinobi_PS2_US_Manual.pdf.jpg",
   "link": "https://archive.org/details/shinobi-ps2-hiresscans",
   "year": 2023
 },
 {
   "id": "Kunoichi",
   "img": "https://cdn.mobygames.com/covers/4435348-nightshade-playstation-2-front-cover.jpg",
   "link": "http://archive.videogamesdaily.com/reviews/ps2/kunoichi.asp",
   "year": 2023
 },
 {
   "id": "Dr Slump",
   "img": "https://images.igdb.com/igdb/image/upload/t_cover_big/co5mv0.jpg",
   "link": "https://www.youtube.com/watch?v=pkgja5bA92k",
   "year": 2023
 },
 {
   "id": "Shadow of Memories",
   "img": "https://static.wikia.nocookie.net/shadowofmemories/images/3/37/Homundraw.gif",
   "link": "https://collectionchamber.blogspot.com/2020/07/shadow-of-destiny-aka-shadow-of-memories.html",
   "year": 2023
 },
 {
   "id": "Brave Fencer Musashi",
   "img": "https://www.giantbomb.com/a/uploads/scale_medium/8/87790/2261092-box_bfm.png",
   "link": "https://www.youtube.com/watch?v=VMT0rAKdZfs",
   "year": 2023
 },
 {
   "id": "Muashi Samurai Legend",
   "img": "https://m.media-amazon.com/images/M/MV5BM2IwZTJiZjQtYTkxNy00OWEwLThlMjEtMDFjYTYzYmUwZmQwL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyNjU3OTI4MDU@._V1_FMjpg_UX1000_.jpg",
   "link": "https://www.youtube.com/watch?v=Qk_SzOIVO3M",
   "year": 2023
 },
 {
   "id": "Stay out of the house",
   "img": "https://cdn.mobygames.com/covers/17710663-stay-out-of-the-house-xbox-one-front-cover.jpg",
   "link": "https://store.steampowered.com/app/896520/?utm_source=PCGamingWiki&utm_medium=PCGamingWiki&utm_campaign=PCGamingWiki",
   "year": 2023
 },
 {
   "id": "Exoprimal",
   "img": "https://cdn.mobygames.com/covers/17403538-exoprimal-windows-apps-front-cover.jpg",
   "link": "https://store.steampowered.com/app/12863209/?utm_source=PCGamingWiki&utm_medium=PCGamingWiki&utm_campaign=PCGamingWiki",
   "year": 2023
 },
 {
   "id": "Einhander",
   "img": "https://static.wikia.nocookie.net/einhander/images/1/11/Coverjp.jpg",
   "link": "https://www.youtube.com/watch?v=rXX3vZq3efk",
   "year": 2023
 },
 {
   "id": "R?MJ Mystery Hospital",
   "img": "https://cdn.mobygames.com/covers/7176043-rmj-the-mystery-hospital-sega-saturn-front-cover.jpg",
   "link": "https://www.youtube.com/watch?v=gq01inHeDrg",
   "year": 2023
 },
 {
   "id": "Celeste",
   "img": "https://cdn.mobygames.com/covers/1306778-celeste-windows-apps-front-cover.jpg",
   "link": "https://store.steampowered.com/app/504230/?utm_source=PCGamingWiki&utm_medium=PCGamingWiki&utm_campaign=PCGamingWiki",
   "year": 2023
 },
 {
   "id": "Haunting Ground",
   "img": "https://cdn.mobygames.com/f79274c8-abc5-11ed-aa5a-02420a0001a0.webp",
   "link": "https://www.mobygames.com/game/18429/haunting-ground/",
   "year": 2023
 },
 {
   "id": "Doom 2016",
   "img": "https://cdn.mobygames.com/covers/1312767-doom-windows-inside-cover.png",
   "link": "https://www.pcgamingwiki.com/wiki/Doom_(2016)",
   "year": 2023
 },
 {
   "id": "Omega Strikers",
   "img": "https://cdn.mobygames.com/covers/17165656-omega-strikers-xbox-one-front-cover.jpg",
   "link": "https://www.pcgamingwiki.com/wiki/Omega_Strikers",
   "year": 2023
 },
 {
   "id": "Idol Showdown",
   "img": "https://howlongtobeat.com/games/128284_Idol_Showdown.jpg?width=250",
   "link": "https://www.pcgamingwiki.com/wiki/Idol_Showdown",
   "year": 2023
 },
 {
   "id": "Escape Simulator",
   "img": "https://howlongtobeat.com/games/99223_Escape_Simulator.jpg?width=250",
   "link": "https://www.pcgamingwiki.com/wiki/Escape_Simulator",
   "year": 2023
 },
 {
   "id": "Tokobot Plus",
   "img": "https://cdn.mobygames.com/8943566e-abec-11ed-9fde-02420a000132.webp",
   "link": "https://www.mobygames.com/game/49397/tokobot-plus-mysteries-of-the-karakuri/",
   "year": 2023
 },
 {
   "id": "Contra: Shattered Soilder",
   "img": "https://cdn.mobygames.com/15bdfe0c-aba0-11ed-93d8-02420a000198.webp",
   "link": "https://www.mobygames.com/game/7627/contra-shattered-soldier/",
   "year": 2023
 },
 {
   "id": "Street Fighter 6",
   "img": "https://cdn.mobygames.com/covers/17149812-street-fighter-6-xbox-series-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1364780/",
   "year": 2023
 },
 {
   "id": "Crossed Swords",
   "img": "https://cdn.mobygames.com/4d30740e-ab9c-11ed-a519-02420a00019d.webp",
   "link": "https://www.mobygames.com/game/16875/crossed-swords/",
   "year": 2023
 },
 {
   "id": "Gungrave",
   "img": "https://cdn.mobygames.com/242c5762-aba1-11ed-b6ee-02420a00019d.webp",
   "link": "https://www.mobygames.com/game/7739/gungrave/",
   "year": 2023
 },
 {
   "id": "Beton Brual",
   "img": "https://images.igdb.com/igdb/image/upload/t_cover_big/co6di7.png",
   "link": "https://store.steampowered.com/app/2330500/BETON_BRUTAL/",
   "year": 2023
 },
 {
   "id": "Parasite Eve",
   "img": "https://cdn.mobygames.com/0212c496-aba5-11ed-837d-02420a00019b.webp",
   "link": "https://www.mobygames.com/game/3593/parasite-eve/",
   "year": 2023
 },
 {
   "id": "Garage: Bad Dream Adventure",
   "img": "https://cdn.mobygames.com/covers/6926928-garage-windows-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1946430/",
   "year": 2023
 },
 {
   "id": "Rental",
   "img": "https://img.itch.zone/aW1nLzEwMzc5MzI0LnBuZw==/original/DF6E2s.png",
   "link": "https://smarto-club.itch.io/rental",
   "year": 2023
 },
 {
   "id": "Death Trips",
   "img": "https://images.sftcdn.net/images/t_app-icon-m/p/46eafa0b-618f-4cfa-be67-54399f360aaa/1213241176/death-trips-deathtrips-logo.jpg",
   "link": "https://forameuss.itch.io/death-trips",
   "year": 2023
 },
 {
   "id": "The Wailer",
   "img": "https://howlongtobeat.com/games/129254_The_Wailer.jpg?width=250",
   "link": "https://store.steampowered.com/app/2284260/The_Wailer/",
   "year": 2023
 },
 {
   "id": "An Empty House",
   "img": "https://img.itch.zone/aW1nLzEyMDc3NzA5LmpwZw==/original/5EFmRK.jpg",
   "link": "https://organzola.itch.io/an-empty-house",
   "year": 2023
 },
 {
   "id": "Feet in the Snow",
   "img": "https://img.itch.zone/aW1nLzExMDUwMDE4LmdpZg==/508x254%23mbm/m7c7o0.gif",
   "link": "https://abstract-machine.itch.io/feet-in-the-snow",
   "year": 2023
 },
 {
   "id": "Dinner with an Owl",
   "img": "https://howlongtobeat.com/games/92584_Dinner_with_an_Owl.jpg?width=250",
   "link": "https://store.steampowered.com/app/1567420/Dinner_with_an_Owl/",
   "year": 2023
 },
 {
   "id": "Bombrush: Cyberfunk",
   "img": "https://cdn.mobygames.com/covers/17758734-bomb-rush-cyberfunk-xbox-one-front-cover.png",
   "link": "https://www.pcgamingwiki.com/wiki/Bomb_Rush_Cyberfunk",
   "year": 2023
 },
 {
   "id": "Armoured Core VI: Fires of Rubicon",
   "img": "https://cdn.mobygames.com/covers/18706572-armored-core-vi-fires-of-rubicon-xbox-one-front-cover.png",
   "link": "https://store.steampowered.com/app/1888160/",
   "year": 2023
 },
 {
   "id": "Umurangi: Generation",
   "img": "https://howlongtobeat.com/games/78648_Umurangi_Generation.jpg?width=250",
   "link": "https://store.steampowered.com/app/1223500/",
   "year": 2023
 },
 {
   "id": "Baldur's Gate 3",
   "img": "https://cdn.mobygames.com/covers/9749111-baldurs-gate-iii-stadia-front-cover.jpg",
   "link": "https://www.pcgamingwiki.com/wiki/Baldur%27s_Gate_3",
   "year": 2023
 },
 {
   "id": "Escape The Backrooms",
   "img": "https://howlongtobeat.com/games/113741_Escape_the_Backrooms.jpg?width=250",
   "link": "https://store.steampowered.com/app/1943950/Escape_the_Backrooms/",
   "year": 2023
 },
 {
   "id": "Endless Dungeon",
   "img": "https://cdn.mobygames.com/covers/17738939-endless-dungeon-xbox-one-front-cover.png",
   "link": "https://store.steampowered.com/app/1485590/",
   "year": 2023
 },
 {
   "id": "Checkmate Showdown",
   "img": "https://howlongtobeat.com/games/140965_Checkmate_Showdown.jpg?width=250",
   "link": "https://store.steampowered.com/app/1803410/Checkmate_Showdown/",
   "year": 2023
 },
 {
   "id": "Yu-Gi-Oh!: Eternal Duelist Soul",
   "img": "https://www.speedrun.com/static/game/m1mjvk12/cover.png?v=95dff03",
   "link": "https://www.mobygames.com/game/8940/yu-gi-oh-the-eternal-duelist-soul/",
   "year": 2023
 },
 {
   "id": "Lunacid",
   "img": "https://howlongtobeat.com/games/106193_Lunacid.jpg?width=250",
   "link": "https://store.steampowered.com/app/1745510/",
   "year": 2023
 },
 {
   "id": "Hi-Fi Rush",
   "img": "https://cdn.mobygames.com/covers/11290348-hi-fi-rush-windows-apps-front-cover.jpg",
   "link": "https://store.steampowered.com/app/1817230/",
   "year": 2023
 },
 {
   "id": "The Windows are Gone",
   "img": "https://howlongtobeat.com/games/138592_The_Windows_Are_Gone.jpg?width=250",
   "link": "https://store.steampowered.com/app/2590250/The_Windows_Are_Gone/",
   "year": 2023
 },
 {
   "id": "Lethal Company",
   "img": "https://howlongtobeat.com/games/139729_Lethal_Company.jpg?width=250",
   "link": "https://store.steampowered.com/app/1966720/",
   "year": 2023
 },
 {
   "id": "Granblue Fantasy Versus: Rising",
   "img": "https://howlongtobeat.com/games/129687_Granblue_Fantasy_Versus_-_Rising.jpg?width=250",
   "link": "https://store.steampowered.com/app/2157560/",
   "year": 2023
 },
 {
   "id": "Tail Concerto",
   "img": "https://cdn.mobygames.com/covers/5109935-tail-concerto-playstation-front-cover.jpg",
   "link": "https://www.mobygames.com/game/8483/tail-concerto/",
   "year": 2023
 }, 
 {
   "id": "Fading Afternoon",
   "img": "https://howlongtobeat.com/games/136416_Fading_Afternoon.jpg?width=250",
   "link": "https://store.steampowered.com/app/1687000/Fading_Afternoon/",
   "year": 2024
 }, 
{ 
 "id": "Assault Spy", 
  "img": "https://howlongtobeat.com/games/62041_Assault_Spy.jpg?width=250",
  "link": "https://store.steampowered.com/app/767930/Assault_Spy/",
  "year": 2024
 }, 
{ 
 "id": "The Evil Within", 
  "img": "https://cdn.mobygames.com/covers/2806572-the-evil-within-xbox-one-front-cover.jpg",
  "link": "https://store.steampowered.com/app/268050/The_Evil_Within/",
  "year": 2024
 }, 
{ 
 "id": "Under Night 2",
  "img": "https://www.arcsystemworks.com/wp-content/uploads/2023/10/UNI-2-Box-Art.jpg",
  "link": "https://store.steampowered.com/app/2076010/UNDER_NIGHT_INBIRTH_II_SysCeles/",
  "year": 2024
 }, 
{ 
 "id": "Granblue Fantasy Relink",
  "img": "https://howlongtobeat.com/games/66500_Granblue_Fantasy_Relink.jpg?width=250",
  "link": "https://store.steampowered.com/app/881020/Granblue_Fantasy_Relink/",
  "year": 2024

 }, 
{ 
 "id": "It Takes Two",
  "img": "https://cdn.mobygames.com/covers/5918747-it-takes-two-windows-front-cover.jpg",
  "link": "https://store.steampowered.com/app/1426210/It_Takes_Two/",
  "year": 2024
 }, 
{ 
 "id": "Slave Zero X",
  "img": "https://cdn.mobygames.com/covers/18266605-slave-zero-x-xbox-one-front-cover.jpg",
  "link": "https://store.steampowered.com/app/1903910/Slave_Zero_X/",
  "year": 2024
 }, 
{ 
 "id": "Helldivers 2",
  "img": "https://howlongtobeat.com/games/129232_Helldivers_2.jpg?width=250",
  "link": "https://store.steampowered.com/app/553850/HELLDIVERS_2/",
  "year": 2024
 }, 
{ 
 "id": "Dragons Dogma 2",
  "img": "https://cdn.mobygames.com/covers/18396430-dragons-dogma-ii-xbox-series-front-cover.jpg",
  "link": "https://store.steampowered.com/app/2054970/Dragons_Dogma_2/",
  "year": 2024
 }, 
{ 
 "id": "Dragon Ball Z: Super Saiya Densetsu",
  "img": "https://cdn.mobygames.com/8898b202-ab6c-11ed-9ab3-02420a0001a0.webp",
  "link": "https://www.mobygames.com/game/13837/dragon-ball-z-super-saiya-densetsu/",
  "year": 2024
 },
{ 
 "id": "Super Dragon Ball Heros: World Mission",
  "img": "https://howlongtobeat.com/games/66141_Super_Dragon_Ball_Heroes_World_Mission.jpg?width=250",
  "link": "https://store.steampowered.com/app/798510/SUPER_DRAGON_BALL_HEROES_WORLD_MISSION/",
  "year": 2024
 },
{ 
 "id": "Fallout: New Vegas",
  "img": "https://howlongtobeat.com/games/3351_Fallout_New_Vegas.jpg?width=250",
  "link": "https://store.steampowered.com/app/22380/Fallout_New_Vegas/",
  "year": 2024
 },
{ 
 "id": "Nikke",
  "img": "https://cdn.mobygames.com/covers/11116724-goddess-of-victory-nikke-iphone-front-cover.jpg",
  "link": "https://nikke-en.com/download.html",
  "year": 2024
 }, 
{ 
 "id": "Void Stranger",
  "img": "https://howlongtobeat.com/games/136378_Void_Stranger.jpg?width=250",
  "link": "https://store.steampowered.com/app/2121980/Void_Stranger/",
  "year": 2024
 }, 
{ 
 "id": "Resident Evil Outbreak", 
  "img": "https://cdn.mobygames.com/covers/4118269-resident-evil-outbreak-playstation-2-front-cover.jpg",
  "link": "https://www.mobygames.com/game/12549/resident-evil-outbreak/",
  "year": 2024
 }, 
{ 
 "id": "Crow Country",
  "img": "https://cdn.mobygames.com/covers/18746797-crow-country-xbox-series-front-cover.png",
  "link": "https://store.steampowered.com/app/1996010/Crow_Country/",
  "year": 2024
 }, 
{ 
 "id": "Devil Blade Reboot",
  "img": "https://howlongtobeat.com/games/151031_Devil_Blade_Reboot.jpg?width=250",
  "link": "https://store.steampowered.com/app/2882440/DEVIL_BLADE_REBOOT/",
  "year": 2024
 }, 
{ 
 "id": "Nightmare Kart",
  "img": "https://howlongtobeat.com/games/150875_Nightmare_Kart.jpg?width=250",
  "link": "https://store.steampowered.com/app/2930160/Nightmare_Kart/",
  "year": 2024
 }, 
{ 
 "id": "Kunitsu Gami Path of the Goddess", 
  "img": "https://cdn.mobygames.com/covers/19161060-kunitsu-gami-path-of-the-goddess-windows-apps-front-cover.jpg",
  "link": "https://store.steampowered.com/app/2510710/KunitsuGami_Path_of_the_Goddess/",
  "year": 2024
 }, 
{ 
 "id": "2XKO", 
  "img": "https://howlongtobeat.com/games/145926_2XKO.jpg?width=250",
  "link": "https://2xko.riotgames.com/en-us/",
  "year": 2024
 }, 
{ 
 "id": "Dragonball Project Multi", 
  "img": "https://howlongtobeat.com/games/155055_DRAGON_BALL_PROJECTMulti.jpg?width=250",
  "link": "https://store.steampowered.com/app/2072560/DRAGON_BALL_PROJECTMulti/",
  "year": 2024
 }, 
{ 
 "id": "Black Myth Wukong", 
  "img": "https://howlongtobeat.com/games/82089_Black_Myth_Wukong.jpg?width=250",
  "link": "https://store.steampowered.com/app/2358720/Black_Myth_Wukong/",
  "year": 2024
 }, 
{ 
 "id": "Byte Breakers", 
  "img": "https://shared.steamstatic.com/store_item_assets/steam/apps/2503080/header.jpg?t=1734441434",
  "link": "https://steamcommunity.com/app/2503080",
  "year": 2024
 }, 
{ 
 "id": "Final Fantasy XVI", 
  "img": "https://cdn.mobygames.com/covers/17205017-final-fantasy-xvi-playstation-5-front-cover.jpg",
  "link": "https://store.steampowered.com/app/2515020/FINAL_FANTASY_XVI/",
  "year": 2024
 }, 
{ 
 "id": "Dragon Ball: Sparking! Zero", 
  "img": "https://cdn.mobygames.com/covers/19258966-dragon-ball-sparking-zero-xbox-series-front-cover.png",
  "link": "https://store.steampowered.com/app/1790600/DRAGON_BALL_Sparking_ZERO/",
  "year": 2024
 }, 
{ 
 "id": "UFO50", 
  "img": "https://howlongtobeat.com/games/75152_UFO_50.jpg?width=250",
  "link": "https://store.steampowered.com/app/1147860/UFO_50/",
  "year": 2024
 }, 
{ 
 "id": "Romnacing Saga 2: Revenge of the Seven", 
  "img": "https://howlongtobeat.com/games/152391_Romancing_SaGa_2_Revenge_of_the_Seven.jpg?width=250",
  "link": "https://store.steampowered.com/app/2455640/Romancing_SaGa_2_Revenge_of_the_Seven/",
  "year": 2024
 }, 
{ 
 "id": "Mouthwashing", 
  "img": "https://howlongtobeat.com/games/145368_Mouthwashing.jpg?width=250",
  "link": "https://store.steampowered.com/app/2475490/Mouthwashing/",
  "year": 2024
 }, 
{ 
 "id": "Prince of Persia: The Lost Crown", 
  "img": "https://cdn.mobygames.com/covers/18131354-prince-of-persia-the-lost-crown-xbox-one-front-cover.jpg",
  "link": "https://store.steampowered.com/app/2751000/Prince_of_Persia_The_Lost_Crown/",
  "year": 2024
 }, 
{ 
 "id": "Marvel Rivals", 
  "img": "https://cdn.mobygames.com/covers/19465993-marvel-rivals-playstation-5-front-cover.png",
  "link": "https://store.steampowered.com/app/2767030/Marvel_Rivals/",
  "year": 2024
 }, 
{ 
 "id": "Onimusha: Warlords", 
  "img": "https://cdn.mobygames.com/covers/6200187-onimusha-warlords-xbox-one-front-cover.jpg",
  "link": "https://store.steampowered.com/app/761600/Onimusha_Warlords/",
  "year": 2024
 }, 
]